import { AnimationController } from '@ionic/angular';

/**
 * Custom navigation transition animation
 * Forward navigation: slides up from bottom (Android/web modal style)
 * Back navigation: slides down to bottom
 */
export const androidTransitionAnimation = (baseEl: HTMLElement, opts?: any) => {
  const animationCtrl = new AnimationController();
  const enteringView = opts.enteringEl;
  const leavingView = opts.leavingEl;
  const direction = opts.direction;

  const rootTransition = animationCtrl.create();

  if (direction === 'forward') {
    // Forward navigation: new page slides up from bottom
    rootTransition
      .addElement(enteringView)
      .duration(200)
      .easing('ease-out')
      .beforeAddClass('show-page')
      .fromTo('transform', 'translateY(200px)', 'translateY(0%)')
      .fromTo('opacity', 0, 1);

    // Previous page fades out slowly to avoid gap
    if (leavingView) {
      const leavingTransition = animationCtrl.create()
        .addElement(leavingView)
        .duration(200)
        .easing('ease-in')
        .fromTo('opacity', 1, 0);

      rootTransition.addAnimation(leavingTransition);
    }
  } else if (direction === 'back') {
    // Back navigation: ensure entering view is ready first
    if (enteringView) {
      const enteringTransition = animationCtrl.create()
        .addElement(enteringView)
        .duration(50)
        .easing('ease-out')
        .beforeAddClass('show-page')
        .fromTo('transform', 'translateY(200px)', 'translateY(0%)')
        .fromTo('opacity', 0, 1);

      rootTransition.addAnimation(enteringTransition);
    }

    // Current page slides down and fades out
    rootTransition
      .addElement(leavingView)
      .duration(200)
      .easing('ease-in')
      .fromTo('transform', 'translateY(0%)', 'translateY(200px)')
      .fromTo('opacity', 1, 0);
  } else {
    // Default fallback for other directions
    rootTransition
      .addElement(enteringView)
      .duration(200)
      .easing('ease-out')
      .beforeAddClass('show-page')
      .fromTo('transform', 'translateY(200px)', 'translateY(0%)')
      .fromTo('opacity', 0, 1);
  }

  return rootTransition;
};
